export default __webpack_public_path__ + "static/habr-18548f68a35bb36d5eb9e6fda0abd72d.svg";